import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PassphraseResponse } from '../models/passphrase/passphrase.model';
import { environment } from 'src/environments/environment';
import { SucccessResponse } from '../interfaces/response/succcess-response';

@Injectable({
  providedIn: 'root'
})
export class PassphraseService {
  api_url = environment.apiEndpoint;
  constructor(private httpClient: HttpClient) {}

  post(): Observable<SucccessResponse> {
    return this.httpClient.post<SucccessResponse>(this.api_url + 'passphrase', null);
  }
}
